import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./styles/index.css";
import "./styles/styles.scss";
import App from "./App";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { setupAxiosInterceptor } from "./utils/axiosInterceptor";

// [2026-02-11] Cookie auth: Enable credentials globally for all axios requests
axios.defaults.withCredentials = true;

// Initialize axios interceptor for automatic logout on 401 errors
// This must be called before any API requests are made
setupAxiosInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

// [2026-06-23T11:30] deploy-trigger: rebuild to pick up verify-email template fix (proper <a> button) + impersonation
